var NiceSelectOptionEl=Backbone.Ribs.View.extend({
    tagName:'div',
    className:'select-option',
    bindings:{
        el:{
            classes:{
                active:'model.selected'
            }
        },
        div:{
            text:'model.name'
        }
    },
    events:{
        "click":"onClick"
    },
    initialize:function(options)
    {
        this.$el.html('<div></div><span class="glyphicon glyphicon-ok check-mark"></span>');
    },
    onClick:function()
    {
        this.collection.trigger("selected",this.model);
        this.model.set("selected",true);
    }
});

var NiceSelectEl=Backbone.Ribs.View.extend({
    collection:null,
    value:null,
    bindings:{
        el:{
            collection:{
                col:'collection',
                view:NiceSelectOptionEl
            }
        }
    },
    initialize:function(options)
    {
        this.$el.fadeIn();
        this.collection=options.col;
        this.collection.on("selected",_.bind(this.clearAllSelect,this));
    },
    clearAllSelect:function(model)
    {
        console.log("clean all");
        _.each(this.collection.models,function(model){
            model.set("selected",false);
        });
        this.value=null;
        if(!_.isUndefined(model))
        {
            this.value=model.get("id");
        }
        this.trigger("change");
    }
});

var NiceSelect=function(el)
{
    this.init($(el));
};

_.extend(NiceSelect.prototype,{
    options:null,
    view:null,
    init:function($el)
    {
        this.$el=$el;
        this.$wel=$el.wrap('<div class="nice-select"></div>').parent();
        this.$el.hide();
        this.$wel.append('<div class="content"></div>');
        this.$select=this.$wel.find(".content")[0];
        var opts=[];
        this.$el.find("option").each(function(i,option) {
            option=$(option);
            opts.push(new Backbone.Ribs.Model({id:option.attr("value"),selected:!!option.attr("selected"), name:option.text()}));
        });

        this.options=new Ribs.Collection(opts);
        this.view=new NiceSelectEl({el:this.$select,col:this.options});
        this.view.on("change",_.bind(this.onChange,this));
    },
    onChange:function()
    {
        this.$el.find("option").each(function(i,item){
            $(item).prop("selected",false);
        });
        this.$el.find("[value='"+this.view.value+"']").attr("selected", "selected");
        this.$el.val(this.view.value).change();
    }
});


$(function(){
    var selects=$(".multilevelselect");
    $(selects).each(function(i,item){
        item.niceselect=new NiceSelect(item);
    });
});
console.log("Nice select init");